$(document).ready(function(){
    $(".item-menu-mb.haschild .menu-parent a.sliderow__title").click(function(e){
        e.preventDefault();
        $(this).parents(".menu-parent").siblings(".child").slideToggle();
        $(this).siblings(".toggle-menu").toggleClass("top");
    });
    $(".has-child .menu-parent-child.child-active a").click(function(e){
        e.preventDefault();
        $(this).parents(".menu-parent-child").siblings(".grandchild").slideToggle();
        $(this).siblings(".toggle-menu").toggleClass("top");
    });
});